module.exports = __webpack_public_path__ + "img/menu-7.8a7b0b5e.svg";